import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Shared empty/error panel for missing routes and failed surah loads.
 */
function PageStatus({
  title,
  message,
  primaryTo = '/',
  primaryLabel = 'Go home',
  onRetry,
  retryLabel = 'Retry',
}) {
  return (
    <div
      className="container mx-auto mt-8 p-6 text-center sm:max-w-full"
      style={{ maxWidth: '800px' }}
    >
      <div className="rounded-3xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-700 dark:bg-gray-800">
        <h2 className="mb-2 text-xl font-semibold text-gray-800 dark:text-gray-200">
          {title}
        </h2>
        {message ? (
          <p className="mb-6 text-gray-600 dark:text-gray-400">{message}</p>
        ) : (
          <div className="mb-6" />
        )}
        <div className="flex flex-wrap items-center justify-center gap-3">
          {typeof onRetry === 'function' && (
            <button
              type="button"
              onClick={onRetry}
              className="rounded-full bg-teal-600 px-4 py-2 text-sm font-medium text-white hover:bg-teal-700"
            >
              {retryLabel}
            </button>
          )}
          <Link
            to={primaryTo}
            className="rounded-full border border-gray-300 px-4 py-2 text-sm font-medium text-gray-800 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-100 dark:hover:bg-gray-700"
          >
            {primaryLabel}
          </Link>
        </div>
      </div>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <PageStatus
      title="Page not found"
      message="That link doesn’t match any page in this app."
      primaryLabel="Back to home"
    />
  );
}

export default PageStatus;
